module.exports = __webpack_public_path__ + "static/media/eu_logo.18f74b7b.png";